import { Box, Text } from '@mantine/core';
import SubscriptionSelectorForm from './SubscriptionSelectorForm';

const SuggestSubscription = ({
  subscriptions,
  newSubscriptions: selectedSubscriptions,
  setNewSubscriptions: setSelectedSubscriptions,
  requestedActionToUnlock,
  domainSubscriptionType,
}) => {
  const suggestedSubscriptions = subscriptions
    .filter((sub) => {
      return sub.allowedActions.includes(requestedActionToUnlock) || sub.allowedActions.includes('*');
    })
    .filter((sub) => sub.type === domainSubscriptionType);

  return (
    <>
      {suggestedSubscriptions.length > 0 ? (
        <SubscriptionSelectorForm
          subscriptions={suggestedSubscriptions}
          selectedSubscriptions={selectedSubscriptions}
          setSelectedSubscriptions={setSelectedSubscriptions}
          suggestType={domainSubscriptionType}
        />
      ) : (
        <Box mt="md">
          <Text ta="center">
            There are no subscription upgrades available for your account at this time.
            <br />
            <br />
            Please contact <a href="mailto:support@releva.ai">support@releva.ai</a> to unlock this feature.
          </Text>
        </Box>
      )}
    </>
  );
};

export default SuggestSubscription;
